module.exports = __webpack_public_path__ + "media/images/lb/374-72a3b9fb47d9d3325a2343feffd1e17a.svg";